// removed by extract-text-webpack-plugin
module.exports = {"container":"_13gFX","story":"JNuQO","video":"_15sNx","image-container":"_1z2rR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RichStory/RichStory.scss
// module id = ./src/components/RichStory/RichStory.scss
// module chunks = 5